import Link from "next/link";
import React, { ReactNode, RefObject } from "react";

interface ButtonProps {
  link?: string; // Se fornito, il bottone diventa un link
  onClick?: (e?: any) => void; // Gestore di eventi per il click
  children: ReactNode; // Contenuto del bottone
  className?: string; // Stili personalizzati
  disabled?: boolean;
  type?: "button" | "submit" | "reset"; // Tipo del bottone
  variant?: "primary" | "secondary" | "outline" | "danger" | "none" | "icon"; // Varianti di stile
  ref?: any;
}

// Mappa delle classi per le varianti
const variantClasses = {
  primary: "bg-blue-500 text-white border-blue-500 hover:bg-blue-600",
  secondary: "bg-gray-500 text-white border-gray-500 hover:bg-gray-600",
  outline: "bg-transparent text-blue-500 border-blue-500 hover:bg-blue-100",
  danger: "bg-red-500 text-white border-red-500 hover:bg-red-600",
  none: "",
  icon: "p-2"
};

const Button: React.FC<ButtonProps> = ({
  link,
  onClick,
  children,
  disabled = false,
  className = "",
  type = "button",
  variant = "none",
  ref
}) => {
    const baseClasses = "flex items-center justify-center px-4 py-2 border rounded-md text-center font-medium hover:bg-opacity-90 transition-all ease-in-out transform-gpu"
    const disabledClasses = "opacity-50 cursor-not-allowed"; // Classes for disabled state
    const combinedClasses = `${baseClasses} ${variantClasses[variant]} ${className} ${disabled ? disabledClasses : ""}`;

    if (link) {
        return (
        <Link href={link} className={combinedClasses}>
            {children}
        </Link>
        );
    }

    return (
        <button
            ref={ref}
            disabled={disabled}
            type={type}
            onClick={onClick}
            className={combinedClasses}
        >
        {children}
        </button>
    );
};

export default Button;
